import React from 'react';
import CommitteeMemberContainer from '../../../Containers/AdminContainer/CommitteeMember';
const CommitteeMemberScreen = () => {
  return <CommitteeMemberContainer />;
};

export default CommitteeMemberScreen;
